import * as React from 'react';
import { FC } from 'react';
import styles from './mobile-navigation.module.sass';
import { YoToolMenu } from '@yakoffice/shared-components';
import { useMobileNavigation } from './use-mobile-navigation/use-mobile-navigation';
import { PublisherNavigationRailItems } from '@yakoffice/publisher-navigation-rail-items';

export type toolId = 'builds' | 'players' | 'publisher' | 'portal';

export const MobileNavigation: FC = () => {

    const {
        authUser,
        yoConfig,
        yoProjects,
        error,
        isDevSite
    } = useMobileNavigation();

    return (authUser && yoConfig &&
        <div className={`${styles.mobileNavigation}`}>
            <YoToolMenu authUser={authUser} toolId={'builds'} isDevSite={isDevSite()} projects={yoProjects} />
            <PublisherNavigationRailItems authUser={authUser} isDevSite={isDevSite()} toolId="builds" />
        </div>
    );
};

